document.addEventListener(
  "click",
  (event) => {
    const eventTarget = event.target;
    if (!(eventTarget instanceof Element)) return;

    const skipLink = eventTarget.closest(".hh-skip-link");
    if (!skipLink) return;

    const target = document.querySelector(skipLink.hash);
    if (!target) return;

    event.preventDefault();
    target.focus({ preventScroll: true });
    target.scrollIntoView({ block: "start" });
  },
  true
);

document.addEventListener("shopify:section:load", () => {});

function initHeroMotion(root = document) {
  root.querySelectorAll("[data-hh-hero-video]").forEach((video) => {
    if (!(video instanceof HTMLVideoElement) || video.dataset.hhMotionReady === "true") return;

    const toggle = video.parentElement?.querySelector("[data-hh-hero-motion]");
    const label = toggle?.querySelector("[data-hh-hero-motion-label]");
    if (!(toggle instanceof HTMLButtonElement) || !(label instanceof HTMLElement)) return;

    video.dataset.hhMotionReady = "true";
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    const setPaused = (paused) => {
      if (paused) {
        video.pause();
      } else {
        video.play().catch(() => {});
      }
      toggle.setAttribute("aria-pressed", String(paused));
      label.textContent = paused ? "Play motion" : "Pause motion";
    };

    setPaused(reducedMotion);
    toggle.addEventListener("click", () => setPaused(!video.paused));
  });
}

initHeroMotion();
document.addEventListener("shopify:section:load", (event) => initHeroMotion(event.target));

function initCountdowns(root = document) {
  root.querySelectorAll("[data-hh-countdown]").forEach((countdown) => {
    if (!(countdown instanceof HTMLElement) || countdown.dataset.hhCountdownReady === "true") return;

    const endTime = Date.parse(countdown.dataset.end || "");
    const status = countdown.parentElement?.querySelector("[data-hh-countdown-status]");
    const values = {
      days: countdown.querySelector('[data-hh-countdown-value="days"]'),
      hours: countdown.querySelector('[data-hh-countdown-value="hours"]'),
      minutes: countdown.querySelector('[data-hh-countdown-value="minutes"]'),
      seconds: countdown.querySelector('[data-hh-countdown-value="seconds"]')
    };

    if (!Number.isFinite(endTime)) {
      countdown.hidden = true;
      if (status instanceof HTMLElement) {
        status.hidden = false;
        status.textContent = "Campaign timing will be announced soon.";
      }
      return;
    }

    countdown.dataset.hhCountdownReady = "true";
    let intervalId;

    const render = () => {
      const remaining = Math.max(0, endTime - Date.now());
      const totalSeconds = Math.floor(remaining / 1000);
      const nextValues = {
        days: Math.floor(totalSeconds / 86400),
        hours: Math.floor((totalSeconds % 86400) / 3600),
        minutes: Math.floor((totalSeconds % 3600) / 60),
        seconds: totalSeconds % 60
      };

      Object.entries(nextValues).forEach(([key, value]) => {
        const target = values[key];
        if (target instanceof HTMLElement) target.textContent = String(value).padStart(2, "0");
      });

      if (remaining === 0) {
        if (intervalId) window.clearInterval(intervalId);
        countdown.hidden = true;
        if (status instanceof HTMLElement) {
          status.hidden = false;
          status.textContent = countdown.dataset.expired || "This campaign has ended.";
        }
      }
    };

    render();
    intervalId = window.setInterval(render, 1000);
  });
}

initCountdowns();
document.addEventListener("shopify:section:load", (event) => initCountdowns(event.target));
